export const MessagesIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={19}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.4}
      d="M3 9.5a6 6 0 1 1 12 0v3.818c0 .636 0 .952-.095 1.206a1.498 1.498 0 0 1-.88.882c-.255.094-.572.094-1.207.094H9a6 6 0 0 1-6-6Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M7 10h4.5m-2.25 3h2.25"
    />
  </svg>
);
